import { useCallback } from 'react';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { unlogin } from '@reducers/utils';
import { navigateTo } from '@helpers';
import { SETTINGS_LIMITED_ROUTE } from '@config/tenantRestrictions';

export const useManageOnHold = () => {
  const dispatch = useAppDispatch();

  const onLogOut = useCallback(() => {
    dispatch(unlogin());
  }, [dispatch]);

  const onSettingsPress = useCallback(() => {
    navigateTo(SETTINGS_LIMITED_ROUTE);
  }, []);

  return { onLogOut, onSettingsPress };
};
